import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const simpleBannerListRootActionPath = 'core/SimpleBannerList/GET';

export const SIMPLE_BANNER_LIST_GET_SUCCESS = `${simpleBannerListRootActionPath}_${SUCCESS_SUFFIX}`;
export const SIMPLE_BANNER_LIST_GET_FAILURE = `${simpleBannerListRootActionPath}_${FAILURE_SUFFIX}`;
